import { HttpTransportType, HubConnectionBuilder, HubConnectionState, NullLogger} from '@microsoft/signalr'
import Vue from 'vue'
import cloneDeep from 'lodash/cloneDeep'

import { eventBus } from '@/main'

const notifyUrl = window.config.GrapgQlUrl + '/notify?accept-language=' + (sessionStorage.language ?? window.config.ui_locales)

let timerChangeState = 0
let timerPeriod = 1000
let countError = 0
let prevState = false
const maxCountError = 20

const changeStateSignal = async (state, timer) => {
  if (state) { countError = 0 }
  if (prevState === state) {
    return
  }
  prevState = state
  if (timer) {
    await new Promise(resolve =>
      timerChangeState = setTimeout(() => {
        Vue.prototype.$store.dispatch('notification/changeActiveSignalR', state)
        eventBus.$emit('ShowSignalErrorReconnecting', !state)
        resolve()
      }, timer))
  } else {
    if (timerChangeState) { clearTimeout(timerChangeState) }
    Vue.prototype.$store.dispatch('notification/changeActiveSignalR', state)
    eventBus.$emit('ShowSignalErrorReconnecting', !state)
  }
  // Ваш код, который должен выполниться после задержки
}


class Notifier {
  isConnecting = false
  hub = {}
  // Контекст запитів GenerateOrganizationReport за ключем — потрібен, щоб кнопка "Повторити"
  // на невдалій генерації (OrganizationReportGenerationError прилітає окремою SignalR-подією,
  // без даних початкового запиту) могла повторно викликати generateOrganizationReportFile
  // з тими самими аргументами. Свідомо не чиститься по завершенню — записів мало (по одній
  // на кожен запуск формування звіту користувачем), пам'яттю можна знехтувати.
  pendingOrganizationReports = new Map()

  async getUserToken() {
    let user = await Vue.prototype.$auth.getUser()
    return user.access_token
  }

  async checHub() {
    // Если идет подключение, то выходим
    if (this.isConnecting) {
      return
    }
    // Если лимит ошибок, то выходим
    if (countError > maxCountError) {
      await changeStateSignal(false, timerPeriod)
      return
    }
    // Если уже есть коннект, то выходим
    if (this.hub && this.hub?.state === HubConnectionState.Connected) {
      await changeStateSignal(true)
      return
    }
    if (!this.hub?.state) {
      countError += 1
      await this.connectNotifiacationHub()
      await changeStateSignal(false, timerPeriod)
      Vue.prototype.$log('Hub not connected')
    } else if (this.hub.state === HubConnectionState.Disconnected) {
      countError += 1
      await this.connectNotifiacationHub()
      await changeStateSignal(false, timerPeriod)
      Vue.prototype.$log('Hub disconnected')
    } else {
      Vue.prototype.$log('checHub - ok')
      await changeStateSignal(true)
    }
  }
  async hubInvoke(name, ...props) {
    return new Promise(async (resolve, reject) => {
      try {
        await this.checHub()
        if (this.hub && typeof this.hub?.invoke === 'function') {
          const result = await this.hub?.invoke(name, ...props)
          resolve(result)
        } else {
          await this.connectNotifiacationHub()
          reject(new Error('Hub or invoke method is not available.'))
        }
      } catch (error) {
        Vue.prototype.$log(`hubInvoke: ${error}`)
        reject(error)
      }
    })
  }


  // таймер реконнекта 5 секунд
  // количество 10
  // если окончательно упал, нужна плашка.
  async connectNotifiacationHub() {
    if (this.isConnecting) {
      return
    }

    try {
      this.isConnecting = true
      if (this.hub?.state && this.hub.state !== HubConnectionState.Disconnected) {
        await this.hub.stop()
      }

      let hubConnection = new HubConnectionBuilder()
        .withUrl(`${notifyUrl}`, {
          skipNegotiation: false,
          withCredentials: true,
          transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling | HttpTransportType.ServerSentEvents,
          accessTokenFactory: () => this.getUserToken()
        })
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: () => {
          // Пауза 5 секунд между попытками переподключения
            return 5000
          },
          retryDelays: retryContext => {
          // максимальное количество попыток переподключения
            if (retryContext.elapsedMilliseconds >= (5000 * 10)) {
              return null // Отключаем автоматическое переподключение после 10 попыток
            }

            // Возвращаемое значение - время для следующей попытки
            return retryContext.elapsedMilliseconds
          },
        })
      //.withAutomaticReconnect()
        .configureLogging(NullLogger)
        .build()

      hubConnection.serverTimeoutInMilliseconds = 1000 * 60 * 10

      hubConnection.onclose(async (error) => {
        Vue.prototype.$log(`hub onclose: ${error}`)
        if (await Vue.prototype.$auth.tokenExpired()) {
          await Vue.prototype.$auth.silentRrenewToken()
        }
        Vue.prototype.$assert(hubConnection.state === HubConnectionState.Disconnected, 'disconnected')
        Vue.prototype.$log(`Closed due to ${error}`)
        changeStateSignal(false, timerPeriod)
        this.checHub()
      })
      hubConnection.onreconnected(async (connectionId) => {
        Vue.prototype.$log(`hub onreconnected: ${connectionId}`)
        changeStateSignal(true)
      })
      /*hubConnection.onreconnecting(async (error) => {
      changeStateSignal(false, 2000)
      //eventBus.$emit('ShowSignalErrorReconnecting', true)
      Vue.prototype.$log_warn(`hub onreconnecting: ${error}`)
      Vue.prototype.$assert(hubConnection.state === HubConnectionState.Reconnecting, 'reconnecting')
      Vue.prototype.$log(`Closed due to ${error}`)
    })*/


      const eventHandlers = {
        TokenExpired: this.tokenExpired,
        RefreshToken: this.refreshToken,
        Events: this.evCallbackPointer,
        TenderUpdate: this.tenderCallbackPointer,
        DownloadFile: this.downloadFileCallbackPointer, //todo добавился ответ. Проверить Successed
        DownloadTenderProtocol: this.downloadTenderProtocolCallbackPointer, //todo добавился ответ. Проверить Successed
        DownloadTenderListFile: this.downloadTenderListFileCallbackPointer, //todo добавился ответ. Проверить Successed
        // .bind(this) обов'язковий — на відміну від інших *CallbackPointer вище, цей
        // хендлер звертається до this.pendingOrganizationReports, а SignalR викликає
        // зареєстровані обробники як голі функції (без прив'язки до інстансу Notifier).
        OrganizationReportGenerationError: this.organizationReportGenerationErrorCallbackPointer.bind(this),
        ArchiveCreationResult: this.archiveCreationResult,
        InnerChatNewMessagesSubmitted: this.InnerChatNewMessagesSubmitted,
        InnerChatMessagesViewed: this.InnerChatMessagesViewed,
        UpdateEventSubscription: this.UpdateEventSubscription,
        UpdateEventsStatuses: this.UpdateEventsStatuses,
        Notification: this.newNotification,
        Connected: this.connected,
        Subscription: this.setSubscription,
      }

      Object.entries(eventHandlers).forEach(([eventName, handler]) => {
        hubConnection.on(eventName, handler)
      })

      await this.start(hubConnection)
      this.isConnecting = false
    } catch (error) {
      this.isConnecting = false
      throw error
    }
  }

  async start(hub) {
    try {
      await hub.start()
      sessionStorage.hubConnectionId = hub.connectionId
      if (hub?.state === HubConnectionState.Connected || hub?.state === HubConnectionState.Connecting) {
        this.hub = hub
        changeStateSignal(true)
        Vue.prototype.$log(this.hub)
      } else {
        changeStateSignal(false, timerPeriod)
      }
    } catch (err) {
      changeStateSignal(false, timerPeriod)
      Vue.prototype.$log('Notifier:', err)
    }
  }

  /**
    * Было создано новое сообщение в чате
    * @param {Guid} chatId
    * @param {Object} messages
  */
  InnerChatNewMessagesSubmitted(model) {
    eventBus.$emit('InnerChatCreateMessages', model )
  }
  /**
   * Что-то поменялось в подписке
   * @param {*} model
   */
  UpdateEventSubscription(model) {
    eventBus.$emit('UpdateEventSubscription', model )
  }
  /**
   * Изменился статус просмотра сообщения
   * @param {*} model
   */
  InnerChatMessagesViewed(model) {
    eventBus.$emit('InnerChatMessagesViewed', model )
  }
  /**
   * Изменился статус просмотра какого-то события
   * @param {*} model
   */
  UpdateEventsStatuses(model) {
    if (model?.length) {
      eventBus.$emit('UpdateEventsStatuses', model)
    }
  }
  /**
   * Новое событие (колокольчик)
   * @param {*} options
   */
  newNotification(options) {
    changeStateSignal(true)
    eventBus.$emit('newNotification', options)
  }
  setSubscription(options) {
    changeStateSignal(true)
    eventBus.$emit('UpdateSubscriptions', options.subscriptions)
    eventBus.$emit('SetLastEvent', options.lastEvents)
  }
  connected() {
    changeStateSignal(true)
  }
  /**
  * Изменение свойств подписки
  */
  async SendUpdateEventSubscription(model) {
    await this.hubInvoke('UpdateEventSubscription', model)
  }
  /**
  * Изменить статус просмотра
  */
  async SendUpdateEventsStatuses(model) {
    await this.hubInvoke('UpdateEventsStatuses', model)
  }
  /**
  * SignalR. Generate inner chat message
  *
  * @param {Guid} chatId
  * @param {Object} messages
  */
  async InnerChatCreateMessages(subscriptionEntityId, messages) {
    const model = {
      subscriptionEntityId: subscriptionEntityId,
      Messages: messages
    }
    try {
      this.hubInvoke('InnerChatCreateMessages', model)
        .then((response) => {
          if (response.successed) {
            eventBus.$emit('InnerChatNewMessagesSuccessed', response.returned)
          }
          return response
        })
    } catch (error) {
      Vue.prototype.$log('Error creating messages:', error)
      throw error
    }
  }
  tokenExpired() {
    const that = this
    Vue.prototype.$log('tokenExpired')
    setTimeout(that.checHub, 1000)
  }
  async refreshToken() {
    /*var exp = await Vue.prototype.$auth.tokenExpired()
    if (exp) {*/
    await Vue.prototype.$auth.silentRrenewToken()
    /*}*/
  }
  evCallbackPointer(options) {
    eventBus.$emit('updateEvents', options)
  }
  downloadTenderProtocolCallbackPointer(param) {
    const key = `tender-${param?.event.tenderId}-protocol`

    let filePath = `/files/getGeneratedTenderReport/${param?.event.fileName}`
    eventBus.$emit('finishFileDownload', {key, filePath})
  }
  downloadFileCallbackPointer(generatedParams) {
    let filePath = `/files/getArchivedFile/${generatedParams.fileName}`
    const key = generatedParams.key || getKey(generatedParams.generateArchiveFileType, generatedParams.tenderId, generatedParams.supplierId)
    eventBus.$emit('finishFileDownload', {key, filePath})
  }
  downloadTenderListFileCallbackPointer(generatedParams) {
    let filePath = `/files/getTenderListFile/${generatedParams.fileId}`

    const key = `tender-${generatedParams.generateFileType}-${generatedParams.addTenderDocuments
      ? 'addTenderDocs'
      : ''}-${generatedParams.addBidsDocuments
      ? 'addBidsDocs'
      : ''}-${generatedParams.addComparisonTable
      ? 'addComparisonTable'
      : ''}-file`
    eventBus.$emit('finishFileDownload', {key, filePath})
  }
  /**
   * Помилка формування загального звіту організації (GenerateOrganizationReport)
   * @param {{key: String, errorCode: String}} params
   */
  organizationReportGenerationErrorCallbackPointer(params) {
    const pending = this.pendingOrganizationReports.get(params?.key)
    const retryProps = pending ? {
      method: 'generateOrganizationReportFile',
      // Порядок ключів має відповідати позиційним аргументам generateOrganizationReportFile —
      // DownloadFiles.vue.repeatFile() викликає this.$notifier[method](...Object.values(methodProps)).
      methodProps: {
        report: pending.report,
        organizationId: pending.organizationId,
        filters: cloneDeep(pending.filters),
        key: pending.key,
      },
    } : {}
    eventBus.$emit('errorFileDownload', { key: params?.key, errorCode: params?.errorCode, ...retryProps })
  }
  tenderCallbackPointer(param) {
    if (param && param.updateType.toLowerCase() === 'agreements') {
      eventBus.$emit('tenderUpdateAgreements', param)
    } else {
      eventBus.$emit('tenderUpdate', true)
    }
  }

  async notify(chatKey,chatKey2,chatType,content) {
    if (chatType == 'APP') {
      chatType = 0
      chatKey2 = chatKey2?.toString()
    }
    await this.hubInvoke('Notify', { chatKey, chatKey2, chatType, content })
  }

  async notifyST(chatId, chatKey, chatType, content) {
    await this.hubInvoke('NotifyTenders', { chatId, chatKey, chatType, content })
  }

  /*
    subscriptionType
    tender        1
    application   2
  */
  async onPage(pageIdentifier, subscriptionType) {
    await this.hubInvoke('OnPage', pageIdentifier, subscriptionType)
  }

  async outPage(pageIdentifier, subscriptionType) {
    await this.hubInvoke('OutPage', pageIdentifier, subscriptionType)
  }

  /**
  * SignalR. Generate new archive file
  *
  * @param {Number} downloadType Option for generate file. 0 = BY_TENDER, 1 = BY_SUPPLIER
  * @param {Number} tenderId
  * @param {Number?} supplierId
  */
  async generateArchivedFile(title, tenderId, supplierId) { //todo
    const downloadType = supplierId === undefined || supplierId === null ? 'BY_TENDER' : 'BY_SUPPLIER'
    const data = {
      organizationItId: Number.parseInt(sessionStorage.getItem('OrganizationItId')),
      tenderId: tenderId,
      supplierId: supplierId || null,
      generateArchiveFileType: downloadType,
      currentCulture: sessionStorage.getItem('language') ?? window.config.ui_locales,
    }
    const hubMethod = this.hubInvoke('GenerateArchivedFile', data)
    await this._handleFileDownload(hubMethod, 'generateArchivedFile',
      {title, tenderId, supplierId},
      {
        key: getKey(downloadType, tenderId, supplierId),
        title,
        tenderId,
        supplierId,
      })
  }
  /**
   * Вызов формирования отчета
   * @param {*} report объект со свойствами отчета
   * @param {*} tenderId ключ тендера
   */
  generateReportFile(report, tenderId, key) {
    this.checHub().then(async () => {
      const data = {
        id: report.id,
        tenderId: tenderId,
        key: key,
      }
      const hubMethod = this.hubInvoke('GenerateReport', data)
      this._handleFileDownload(hubMethod, 'generateReportFile',
        {report, tenderId, key},
        {
          key,
          title: report.title ?? report.name,
          tenderId
        })
    })
  }
  /**
   * Вызов формирования загального звіту організації
   * @param {*} report объект со свойствами отчета
   * @param {Number} organizationId ключ организации
   * @param {Object} filters фильтры отчета (напр. publishedDateFrom/publishedDateTo)
   */
  generateOrganizationReportFile(report, organizationId, filters, key) {
    this.pendingOrganizationReports.set(key, { report, organizationId, filters: cloneDeep(filters), key })
    this.checHub().then(async () => {
      const data = {
        id: report.id,
        organizationId,
        filters,
        key,
      }
      const hubMethod = this.hubInvoke('GenerateOrganizationReport', data)
      this._handleFileDownload(hubMethod, 'generateOrganizationReportFile',
        {report, organizationId, filters, key},
        {
          key,
          title: report.title ?? report.name,
          // Успіх/помилка генерації прилітають окремими SignalR-подіями (DownloadFile /
          // OrganizationReportGenerationError), а не через successed у відповіді hubInvoke.
          ignoreSuccessed: true,
        })
    })
  }
  /**
  * SignalR. Generate new file
  *
  * @param {String} title
  * @param {Object} search
  * @param {String} downloadType
  */
  async geterateTendersToExcel(title, search, downloadType, addTenderDocs, addBidsDocs, addComparisonTable) {
    const key = `tender-${downloadType}-${addTenderDocs ? 'addTenderDocs' : ''}-${addBidsDocs ? 'addBidsDocs'  : ''}-${addComparisonTable ? 'addComparisonTable' : ''}-file`

    const data = {
      organizationItId: Number.parseInt(sessionStorage.getItem('OrganizationItId')),
      generateFileType: downloadType,
      tenderSearchModel: search,
      addTenderDocuments: addTenderDocs,
      addBidsDocuments: addBidsDocs,
      addComparisonTable: addComparisonTable
    }

    const hubMethod = this.hubInvoke('GenerateTenderListFiles', data, sessionStorage.language)
    await this._handleFileDownload(hubMethod, 'geterateTendersToExcel',
      {title, search, downloadType, addTenderDocs, addBidsDocs, addComparisonTable},
      {
        key,
        title
      })
  }
  /**
  * SignalR. Generate tender protocol
  *
  * @param {Number} tenderId
  */
  async generateTenderProtocolFile(title, tenderId) {
    const hubMethod = this.hubInvoke('GenerateTenderProtocol', { tenderId }, Number.parseInt(sessionStorage.getItem('OrganizationItId')), sessionStorage.language)
    await this._handleFileDownload(hubMethod, 'generateTenderProtocolFile',
      {title, tenderId},
      {
        key: `tender-${tenderId}-protocol`,
        title,
        tenderId
      })
  }

  async generateFilesArhive(taskId, arhiveData, title) {
    const hubMethod = this.hubInvoke('startArchiveCreation', taskId, arhiveData)
    await this._handleFileDownload(hubMethod, 'generateFilesArhive',
      {taskId, arhiveData, title},
      {
        key: taskId,
        title,
        taskId,
        ignoreSuccessed: true, // игнорируем successed, т.к. в данную задачу бек его не присылает
      })
  }

  archiveCreationResult(generatedParams) {
    let key = generatedParams.taskId
    if (generatedParams?.isSuccess) {
      let filePath = `/api/document-archive/download/${generatedParams.taskId}`
      eventBus.$emit('finishFileDownload', {key, filePath, fileType: 'archive'})
    } else {
      eventBus.$emit('errorFileDownload', { key })
    }
  }

  /**
   * Общая функция для обработки загрузки файла
   * @param {String} hubMethod Метод SignalR
   * @param {String} method Метод
   * @param {Object} methodProps Данные для вызова метода
   * @param {String} innerProps Данные и различные свойства
   */
  async _handleFileDownload(hubMethod, method, methodProps, innerProps) {
    const emitProps = {
      ...innerProps,
      method: method
    }
    eventBus.$emit('startFileDownload', emitProps)
    try {
      const result = await hubMethod

      if (!innerProps.ignoreSuccessed && !result?.successed) {
        eventBus.$emit('errorFileDownload', { hubMethod, method, methodProps, ...innerProps, errorCode: result?.errorCode })
      }
    } catch (error) {
      eventBus.$emit('errorFileDownload', { hubMethod, method, methodProps, ...innerProps, error })
    }
  }
}

const getKey = (downloadType, tenderId, supplierId) => {
  return `file-type${downloadType}-tender${tenderId}-supplier${supplierId || 'none'}`
}


export default {
  install(Vue) {
    Vue.prototype.$notifier = new Notifier()
  }
}
